import {theme} from "../../../../utils";

export type IModeProps = "terms" | "privacy"

// MAT constants (could be moved up to an app.constants file later)
export const MAT_NUMBER = "MAT-US-NON-2026-00171";
export const MAT_DATE = "04/26";



export const footerStyles = {
    footerWrapper: {
        textAlign: 'center',
        px: '52px',
        backgroundColor: '#1E1E22',
        color: 'white',
        boxShadow: '0px 1px 5px 0px rgba(37, 37, 37, 0.12), 0px 2px 2px 0px rgba(37, 37, 37, 0.14), 0px 3px 1px -2px rgba(37, 37, 37, 0.20)',
        display:"flex",
        flexDirection:'row',
        justifyContent:'center',
        flexWrap: 'wrap',
        gap: '20px'
    },
    footerLabel: {
        ...theme.typography.poppinsBodyRegular,
        color: "#FFFFF",
        fontSize: '14px',
        fontWeight: '400',
        fontStyle: 'normal',
        lineHeight: '20px',
        letterSpacing: '0px'
    }
}